import { render, staticRenderFns } from "./EventsNavComponent.vue?vue&type=template&id=c3c5f0e6"
import script from "./EventsNavComponent.vue?vue&type=script&lang=js"
export * from "./EventsNavComponent.vue?vue&type=script&lang=js"
import style0 from "./EventsNavComponent.vue?vue&type=style&index=0&id=c3c5f0e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports